// import ContactComponent from "../components/ContactComponent";
import ServiceComponent from "../components/ServiceComponent";
import Footer from "../layouts/Footer";
import Header from "../layouts/Header";
import Navbar from "../layouts/Navbar";

function Services() {
  return (
    <>
      <Navbar />
      <Header name="Services" />
      <ServiceComponent />
      <Footer />
    </>
  );
}

export default Services;
